import {useMemo} from 'react'

import useIsIOSMobile from './useIsIOSMobile'
import {getCookie, setCookie} from '@app/utils/cookies'

const COOKIE_NAME = 'isMobileIOS'
const OLD_COOKIE_NAME = 'hideGoogleLoginButton'

const useIsMobileIOSCookieTrue = () => {
  const isIOSMobile = useIsIOSMobile()

  return false // block

  return useMemo(() => {
    if (isIOSMobile) {
      setCookie(COOKIE_NAME, 'true', 'max-age=31536000')
      return true
    }

    const isMobileIOSFromCookie = getCookie(COOKIE_NAME)
    const isMobileIOSFromOldCookie = getCookie(OLD_COOKIE_NAME)

    if (isMobileIOSFromCookie === 'true' || isMobileIOSFromOldCookie === 'true') {
      return true
    }
  }, [isIOSMobile])
}

export default useIsMobileIOSCookieTrue
